export default __webpack_public_path__ + "static/media/anahi.dfc6a0fd.png";